import React from 'react'

import type { TableHeaders } from '@fourthwall/components'
import type { DnsRecord } from '@fourthwall/services/dist/DnsApiClient'

import { DnsRecordCodeCell } from '../components/DnsRecordCodeCell/DnsRecordCodeCell'
import { DnsRecordStatusCell } from '../components/DnsRecordStatusCell/DnsRecordStatusCell'
import { DnsRecordValueCell } from '../components/DnsRecordValueCell/DnsRecordValueCell'

export const getTableHeaders = (isVerificationInProgress: boolean): TableHeaders<DnsRecord> => [
  {
    id: 'type',
    label: 'TYPE',
    render: ({ recordType }) => recordType,
    width: 1,
  },
  {
    id: 'host',
    label: 'HOST',
    render: ({ alias, zoneFile }) => (
      <DnsRecordCodeCell value={zoneFile?.hostLabel || ''} recordAlias={alias} />
    ),
    width: 5,
  },
  {
    id: 'value',
    label: 'VALUE',
    render: (record) => <DnsRecordValueCell record={record} />,
    width: 5,
  },
  {
    id: 'status',
    label: '',
    render: (record) => (
      <DnsRecordStatusCell record={record} isVerificationInProgress={isVerificationInProgress} />
    ),
    width: 1,
    alignment: 'right',
  },
]
